<div class="container-fluid p-2 p-md-3 px-0">
  <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
    <div class="d-flex align-items-center gap-2 flex-wrap">
      <h2 class="mb-0">{{ isMine ? 'Le mie Organizzazioni' : 'Organizzazioni' }}</h2>
      @if (!isMine) {
        <button
          type="button"
          class="btn btn-primary"
          [routerLink]="canCreate() ? '/organizations/add' : null"
          [disabled]="!canCreate()"
          [title]="canCreate() ? '' : 'Non hai i permessi per questa azione'">
          <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>Organizzazione
        </button>
      }
    </div>
    <div class="btn-group" role="group" aria-label="Vista catalogo organizzazioni">
      <button
        type="button"
        class="btn"
        [class.btn-primary]="view() === 'list'"
        [class.btn-outline-primary]="view() !== 'list'"
        [attr.aria-pressed]="view() === 'list'"
        (click)="setView('list')"
      >
        <i class="bi bi-grid me-1" aria-hidden="true"></i>Lista
      </button>
      <button
        type="button"
        class="btn"
        [class.btn-primary]="view() === 'map'"
        [class.btn-outline-primary]="view() !== 'map'"
        [attr.aria-pressed]="view() === 'map'"
        (click)="setView('map')"
      >
        <i class="bi bi-map me-1" aria-hidden="true"></i>Mappa
      </button>
    </div>
  </div>

  @if (!isMine && view() === 'list') {
    <div class="organization-search-bar-container mb-4">
      <div class="row g-2 align-items-center">
        <div class="col">
          <div class="input-group">
            <span class="input-group-text search-icon-addon">
              <i class="bi bi-search" aria-hidden="true"></i>
            </span>
            <input
              type="search"
              class="form-control search-input"
              placeholder="Cerca organizzazioni per nome, descrizione, città..."
              [formControl]="searchControl"
              aria-label="Cerca organizzazioni"
            />
            @if (searchControl.value) {
              <button
                class="btn btn-outline-secondary border-start-0"
                type="button"
                (click)="clearSearch()"
                aria-label="Cancella ricerca"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  }

  @if (isLoading()) {
    <div class="d-flex justify-content-center align-items-center py-5">
      <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;">
        <span class="visually-hidden">Caricamento organizzazioni in corso...</span>
      </div>
    </div>
  } @else if (view() === 'map') {
    <p class="text-muted small mb-2">
      Le sedi si ricavano dagli eventi geolocalizzati delle organizzazioni.
    </p>
    <app-osm-map
      [markers]="mapMarkers()"
      ariaLabel="Mappa delle organizzazioni"
      emptyMessage="Nessuna organizzazione con una posizione nota. Serve almeno un evento con coordinate."
    ></app-osm-map>
  } @else if (visibleOrganizations().length > 0) {
    <app-paginated-list
      [items]="visibleOrganizations()"
      colClass="col-12 col-sm-6 col-md-4 col-lg-3"
      [pageSize]="8"
    >
      <ng-template let-organization>
        @if (isMine || organization.organizationActive) {
          <app-organization-card
            [organization]="organization"
            [events]="events()"
          ></app-organization-card>
        }
      </ng-template>
    </app-paginated-list>
  } @else {
    <div class="container-generic text-center">
      <p class="message-error">
        {{
          isMine
            ? 'Non fai ancora parte di alcuna organizzazione'
            : 'Nessuna organizzazione trovata'
        }}
      </p>
    </div>
  }
</div>
